import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

export default function useGeolocation() {
  const { geolocation } = useSelector(store => store.country)
  const [position, setPosition] = useState(null)

  function success(browserPosition) {
    const {
      coords: { latitude, longitude },
    } = browserPosition
    setPosition({ lat: latitude, lng: longitude })
  }

  function error() {
    setPosition(geolocation)
  }

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(success, error)
    }
  }, [])

  return position
}
